enum WMSConfigEnum {
  MonStock = "MonStock",
  StockIt = "StockIt",
}

export default WMSConfigEnum;

export type StockItConfigType = {
  inputDir?: string;
  outputDir?: string;
  warehouseCode: string;
  ftpHostname?: string;
  ftpUser?: string;
  ftpPassword?: string;
  status: [{ value: string; label: string }];
  providers: [{ companyId: string; code: string }];
};

export type MonStockConfigType = {
  token: string;
  warehouseProviders: { warehouseId: string; code: string }[];
  providers: [{ companyId: string; code: string }];
};

export type WMSConfigType<T> = {
  _id?: string;
  warehouses: string[];
  config: T;
  type: WMSConfigEnum;
};
